// extracted by mini-css-extract-plugin
export default {"chat":"Chat_chat__e1LhW","chatInfo":"Chat_chatInfo__FOPFs","chatIcons":"Chat_chatIcons__7wRfa"};